import { error } from "console";
import { InputfieldTypes } from "../../../../enums/InputFieldAttributesEnums";

export const processingRuleFormConstants = {
  HEADER_TXT: "Edit Ticket Processing Rule",
  SAVE_BTN_TXT: "Save",
  CANCEL_BTN_TXT: "Cancel",
  DRAWER_PLACEMENT: "right",
  DRAWER_SIZE: "large",
  DRAWER_WIDTH: "27.5%",
  DRAWER_HEIGHT: "100vh",
  CANCEL_BTN_CLASS: "cancelChangesButton",
};

export const fieldConstants = {
  UNIQUE_USERS_NAME: "uniqueUsers",
  UNIQUE_USERS_LABEL: "Unique Users",
  UNIQUE_SUBMISSIONS_NAME: "uniqueTktSubmissions",
  UNIQUE_SUBMISSIONS_LABEL: "Unique Ticket Submissions",
  FAILURE_LIMIT_NAME: "ticketFailureLimit",
  FAILURE_LIMIT_LABEL: "Ticket Failure Limit",
  MAX_SUBMISSIONS_NAME: "maxSubmissions",
  MAX_SUBMISSIONS_LABEL: "Maximum no. of submissions",
  NOTES_FIELD_NAME: "ruleNotes",
  NOTES_FIELD_LABEL: "Notes",
};

export const ruleFormFields = [
  {
    type: InputfieldTypes.TEXT,
    label: fieldConstants.UNIQUE_USERS_LABEL,
    name: fieldConstants.UNIQUE_USERS_NAME,
    placeholder: "Enter users",
  },
  {
    type: InputfieldTypes.TEXT,
    label: fieldConstants.UNIQUE_SUBMISSIONS_LABEL,
    name: fieldConstants.UNIQUE_SUBMISSIONS_NAME,
    placeholder: "Enter ticket submissions",
  },
  {
    type: InputfieldTypes.TEXT,
    label: fieldConstants.FAILURE_LIMIT_LABEL,
    name: fieldConstants.FAILURE_LIMIT_NAME,
    placeholder: "Enter failure limit",
  },
  {
    type: InputfieldTypes.TEXT,
    label: fieldConstants.MAX_SUBMISSIONS_LABEL,
    name: fieldConstants.MAX_SUBMISSIONS_NAME,
    placeholder: "Enter max no. of submissions",
  },
  {
    type: InputfieldTypes.TEXT_AREA,
    label: fieldConstants.NOTES_FIELD_LABEL,
    name: fieldConstants.NOTES_FIELD_NAME,
    placeholder: "Enter notes",
    showCount: true,
    maxLength: 500,
  },
];

export const formHeaderStyle = {
  backgroundColor: "#586370",
  padding: "1rem",
  color: "white",
};

export const ruleEngineMessages = {
  success: "Rule engine updated successfully!",
  error: "Failed to update rule engine!",
};
